
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 12a2 2 0 114.001.001A2 2 0 013 12zm9-2a2 2 0 10.001 4.001A2 2 0 0012 10zm7 0a2 2 0 10.001 4.001A2 2 0 0019 10z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 12a2 2 0 114.001.001A2 2 0 013 12zm9-2a2 2 0 10.001 4.001A2 2 0 0012 10zm7 0a2 2 0 10.001 4.001A2 2 0 0019 10z"}})])
          )
        }
      }
    